export const STATE_LOADING = "loading";
export const STATE_AVAILABLE = "available";
export const STATE_DIRECT_LINK_ONLY = "direct-link-only";
export const STATE_UNAVAILABLE = "unavailable";
export const STATE_ALTERNATIVES = "alternatives";
export const STATE_WITHOUT_DATES = "without-dates";
